/**
* Exposed CSS variables
*
* @prop --pagination-font-size: The font size of the pagination default is `1rem`
* @prop --pagination-active-bg: The background color of the pagination when active default is `$orange-100`
* @prop --pagination-item-color: The text color of the pagination item default is `$neutral-400`
* @prop --pagination-active-color: The text color of the pagination when active default is `$orange-500`
* @prop --pagination-gap: The gap between page items default is `0.375rem`
* @prop --pagination-item-padding: The padding of the pagination item default is `0.5rem 1rem`
* @prop --pagination-item-border-radius: The border radius of the pagination item default is `0.375rem`
*/

$small-constant: 0.875;
$large-constant: 1.25;

:host {
  display: block;
  font-family: $base-font-family;
  -webkit-user-select: none;
  user-select: none;
}

ul {
  list-style-type: none;
  display: flex;
  gap: var(--pagination-gap, 0.375rem);
  padding: 0;
  margin: 0;

  li {
    @include center;
    padding: var(--pagination-item-padding, 0.5rem 1rem);
    color: var(--pagination-item-color, $neutral-400);
    border-radius: var(--pagination-tem-border-radius, 0.375rem);
    font-size: var(--pagination-font-size, 1rem);
    cursor: pointer;
    &.active {
      background: var(--pagination-active-bg, $orange-100);
      color: var(--pagination-active-color, $orange-500);
    }
    svg {
      path {
        fill: var(--pagination-item-color, $neutral-400);
      }
    }
    &:focus-visible {
      @include focus;
      border-radius: 0.125rem;
    }
  }
}

ul.size-small {
  gap: calc($small-constant * 0.375rem);
  li {
    padding: calc($small-constant * 0.5rem) calc($small-constant * 1rem);
    font-size: $small-constant * 1rem;
    border-radius: calc($small-constant * 0.375rem);
    svg {
      width: calc($small-constant * 1.5rem);
      height: calc($small-constant * 1.5rem);
    }
  }
}

ul.size-large {
  gap: calc($large-constant * 0.375rem);
  li {
    padding: calc($large-constant * 0.5rem) calc($large-constant * 1rem);
    font-size: $large-constant * 1rem;
    border-radius: calc($large-constant * 0.375rem);
    svg {
      width: calc($large-constant * 1.5rem);
      height: calc($large-constant * 1.5rem);
    }
  }
}
